/**
 * UI Config Service - работа с конфигурацией UI
 */
import { api } from '../core/api';

// ============================================================================
// ТИПЫ
// ============================================================================

export interface UIConfigEntry {
  section: string;
  key: string;
  value: Record<string, unknown>;
  updated_by?: string;
  updated_at?: string;
}

export interface UIConfigHistoryEntry {
  id: string;
  old_value: Record<string, unknown>;
  new_value: Record<string, unknown>;
  changed_by: string;
  changed_at: string;
  comment: string | null;
}

// ============================================================================
// UI CONFIG SERVICE
// ============================================================================

export const uiConfigService = {
  /**
   * Получить все настройки UI
   */
  getAll: () =>
    api.get<UIConfigEntry[]>('/ui-config'),

  /**
   * Получить настройки UI по секции
   */
  getBySection: (section: string) =>
    api.get<UIConfigEntry[]>(`/ui-config/${section}`),

  /**
   * Обновить настройку UI
   */
  update: (section: string, key: string, value: Record<string, unknown>, comment?: string) =>
    api.put<UIConfigEntry>(`/ui-config/${section}/${key}`, { value, comment }),

  /**
   * Получить историю изменений настройки
   */
  getHistory: (section: string, key: string) =>
    api.get<UIConfigHistoryEntry[]>(`/ui-config/${section}/${key}/history`),

  /**
   * Откатить настройку к предыдущему значению
   */
  rollback: (section: string, key: string, historyId: string) =>
    api.post<UIConfigEntry>(`/ui-config/${section}/${key}/rollback`, { historyId }),
};
